import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import DetailsHeaderBar from "../components/DetailsHeaderBar";
import DetailsTopBar from "../components/DetailsTopBar";
import WalletDetails from "../components/WalletDetails";
import cash from "../assets/images/tc-cash-wallet 1.png";
import units from "../assets/images/tc-units-wallet 2.png";
import mini from "../assets/images/tcuk_agent_wallet 2.png";
import wallet2 from '../assets/images/Wallet03.1 1.png';
import wallet1 from '../assets/images/Wallet01 5.png';
import dollarY from '../assets/images/Dollar Bag (1).png';
import dollarG from '../assets/images/Dollar Bag.png';
import history1 from '../assets/images/Group 37483.png';
import oldbank from '../assets/images/bank-pound-icon2 4.png';
import gift from '../assets/images/Gift.png';
import "../styles/AdvertisingAgentWallet.css";
import "../styles/WalletPage.css";
import { resolveCustomerRecord } from "../services/customerServices";

function AdvertisingAgentWallet() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  if (!agent) {
    return <p style={{ padding: "30px" }}>No more data available.</p>;
  }

  // Extract wallet data from the nested structure
  const agentWalletBalance =
    agent.wallet_details?.agent_wallet_details?.points ||
    agent.agent_details?.wallet_balance ||
    agent.agent_wallet_points ||
    0;

  const agentCashBalance =
    agent.wallet_details?.agent_wallet_details?.cash ||
    agent.agent_details?.total_commissions ||
    0;

  const customerWalletBalance =
    agent.customer_details?.wallet_details?.total_points ||
    agent.customer_wallet_points ||
    agent.wallet_details?.total_points ||
    0;

  const earnedTopCoinPoints =
    agent.customer_details?.wallet_details?.earned_top_coinown?.points ||
    agent.wallet_details?.earned_top_coinown?.points ||
    agent.earned_top_coinown?.units ||
    0;

  const earnedBonusCash =
    agent.customer_details?.wallet_details?.earned_bonus_reward_wallet?.cash ||
    agent.wallet_details?.earned_bonus_reward_wallet?.cash ||
    0;

  const primaryWalletBalance =
    agent.customer_details?.wallet_details?.primary_wallet?.points ||
    agent.wallet_details?.primary_wallet?.points ||
    0;

  // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/advertising-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/advertising-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/advertising-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Request Details",
      path: "/advertising-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);
  const customerRecord = resolveCustomerRecord(agent.customer_details || agent);

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
          title="Advertising Agent Details"
          subtitle="You can edit your details to update your profile"
          breadcrumbs={[
            { label: "Home", path: "/dashboard" },
            {
              label: "Manage Ads Agents",
              path: "/manage-advertising-agent",
            },
            { label: "Advertising Agent Details" },
          ]}
        />
        <DetailsTopBar tabs={tabs} activeTab="wallet" agent={agent} />
        <div className="wallet-section">
          {/* WALLET ROW 1 - CUSTOMER WALLETS */}
            <WalletDetails
              imgH={wallet2}
              imgT={dollarG}
              imgHi={history1}
              title="Sign-Up reward TopCoin"
              amount={`${primaryWalletBalance} TopCoin`}
              subText="Available TopCoin"
              bgColor="#f0fdf4"
              bgColor1="#dcfce7"
              historyLink="/advertising-agent-transaction-history"
              stateData={{ agent }}
            />

            <WalletDetails
              imgH={wallet2}
              imgT={dollarG}
              imgHi={history1}
              title="Earned TopCoin Wallet"
              amount={`${earnedTopCoinPoints} TopCoin`}
              subText="Available TopCoin"
              bgColor="#f0fdf4"
              bgColor1="#dcfce7"
              showButton={false}
            />

            <WalletDetails
              imgH={wallet1}
              imgT={dollarY}
              imgHi={history1}
              title="Earned Bonus Reward Wallet (Customer)"
              amount={`£ ${earnedBonusCash}`}
              subText="Available Cash"
              bgColor="#fff7ed"
              bgColor1="#ffedd5"
              showButton={false}
            />

          {/* WALLET ROW 2 - AGENT NETWORK WALLETS */}
            <WalletDetails
              imgH={wallet1}
              imgT={gift}
              imgHi={history1}
              title="Advertising Agent TopCoin Wallet (Network)"
              amount={`${Math.trunc(agentWalletBalance)} TopCoin`}
              subText="Available TopCoin"
              bgColor="#eff6ff"
              bgColor1="#dbeafe"
              historyLink="/advertising-agent-transaction"
              stateData={{ agent }}
            />

            <WalletDetails
              imgH={wallet1}
              imgT={dollarY}
              imgHi={history1}
              title="Advertising Agent Cash Wallet"
              amount={`£ ${Number(agentCashBalance).toFixed(2)}`}
              subText="Available Cash"
              bgColor="#fff7ed"
              bgColor1="#ffedd5"
              showButton={false}
            />

            <WalletDetails
              imgH={oldbank}
              imgT={dollarY}
              title="Withdraw"
              amount={`£ ${(0).toFixed(2)}`}
              subText="Available Cash"
              bgColor="#f5f5f5"
              bgColor1="#e0e0e0"
              buttonText="Withdraw"
              disabled={true}
              showButton={true}
            />
        </div>

        <div className="wallet-section">
          <Link
            to="/customer-sales-history"
            state={{ customer: customerRecord, agent, fromAgent: true }}
            className="wallet-link"
            style={{ fontSize: "14px" }}
          >
            View Retail Sales History &gt;&gt;
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdvertisingAgentWallet;
